<div [class]="field.styleValue" [attr.lang]="metadataValue.language">
    <span class="d-flex align-items-center txt-value">

      <a *ngIf="(orcidUrl$ | async); else noOrcidUrl" href="{{(orcidUrl$ | async)}}/{{metadataValue.value}}" target="_blank">
        {{ metadataValue.value }}
      </a>

      <ng-template #noOrcidUrl>{{ metadataValue.value }}</ng-template>

      <img *ngIf="hasOrcidBadge()"
           placement="top"
           ngbTooltip="{{ 'orcid.badge.tooltip' | translate }}"
           class="orcid-icon"
           alt="orcid-logo"
           src="assets/images/orcid.logo.icon.svg"/>

    </span>
</div>
